import React from "react";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const TERMS_LABELS: Record<string, string> = {
  CREDIT_CARD: "Credit Card",
  ACH_TRANSFER: "ACH",
};

const formatTerms = (terms: string | null): string => {
  if (terms == null) return "No Payment Method";
  return TERMS_LABELS[terms] ?? terms;
};

interface TermsCellProps {
  terms: string | null;
  fallbackInUse: boolean;
}

export const TermsCell: React.FC<TermsCellProps> = ({
  terms,
  fallbackInUse,
}) => (
  <span className="inline-flex items-center gap-1 text-gray-900 dark:text-white">
    <span>{formatTerms(terms)}</span>
    {fallbackInUse && (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              aria-label="Billed at the company-default rate"
              className="inline-flex h-4 w-4 items-center justify-center text-blue-500 dark:text-blue-400"
            >
              <Info className="h-4 w-4" />
            </span>
          </TooltipTrigger>
          <TooltipContent>
            Billed at the company-default rate — no payment method on file in
            CARA yet. The invoice will sit in Accounts Receivable until the
            customer enters a payment method in CARA.
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )}
  </span>
);
